<template>
    <div>
        <report-header
            :title="title"
            :isLoading="isLoading"
            :reportPagination="pagination"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />

        <b-card id="report-card">
            <div v-if="!loaded">
                <p class="mt-3">
                    Please select the
                    <a @click="handleOpenFilter" class="text-link">filter</a>
                </p>
            </div>
            <div id="report-body" v-if="loaded" class="w-100">
                <div class="summary-table">
                    <div
                        class="d-flex justify-content-between align-items-center"
                    >
                        <h4 class="mt-3">Summary</h4>
                        <button
                            type="button"
                            class="btn"
                            @click="handleOpenFilter"
                        >
                            <span v-if="params.is_active_users == 0"
                                >Show Active PetCare Users</span
                            >
                            <span v-else-if="params.is_active_users == 1"
                                >Show All PetCare Users</span
                            >
                        </button>
                    </div>
                    <b-table-simple class="mb-4">
                        <tbody>
                            <tr style="border: none;">
                                <td class="" style="border: none;">
                                    <i
                                        v-if="params.is_active_users == 0"
                                        class="arrow right"
                                    ></i>
                                    {{ totalClientLoggedInTitle }}
                                </td>
                                <td class="" style="border: none;">
                                    {{ totalLoggedIn }}
                                </td>
                            </tr>
                            <tr style="border: none;">
                                <td class="" style="border: none;">
                                    <i
                                        v-if="params.is_active_users == 1"
                                        class="arrow right"
                                    ></i>
                                    {{ totalClientActiveTitle }}
                                </td>
                                <td class="" style="border: none;">
                                    {{ totalActive }}
                                </td>
                            </tr>
                        </tbody>
                    </b-table-simple>
                </div>
                <div v-if="results.length > 0">
                    <QTable
                        :data="results"
                        :columns="columns"
                        :loading="isLoading"
                        :rows-per-page-options="[0]"
                        row-key="index"
                        hide-bottom
                    >
                        <template v-slot:body-cell-firstname="props">
                            <q-td :props="props" class="">
                                <client-name
                                    v-if="USE_CLIENT_MODULE_VUE"
                                    :client="props.row.client"
                                    :text="props.row.firstname"
                                />
                                <a v-else :href="getClientURI(props.row.id)">
                                    {{ props.row.firstname }}
                                </a>
                            </q-td>
                        </template>
                        <template v-slot:body-cell-lastname="props">
                            <q-td :props="props" class="">
                                <client-name
                                    v-if="USE_CLIENT_MODULE_VUE"
                                    :client="props.row.client"
                                    :text="props.row.lastname"
                                />
                                <a
                                    v-else
                                    :href="getClientURI(props.row.encoded_id)"
                                >
                                    {{ props.row.lastname }}
                                </a>
                            </q-td>
                        </template>
                    </QTable>
                </div>
                <div v-else>
                    <QTable
                        :data="[]"
                        :columns="columns"
                        :loading="isLoading"
                        :rows-per-page-options="[0]"
                        row-key="index"
                        hide-bottom
                    ></QTable>
                    <div class="py-3" v-if="!isLoading">
                        <i>No records available</i>
                    </div>
                </div>
            </div>
        </b-card>

        <FilterPetCareUser
            ref="filterPetCareUser"
            :data="{ show: params.is_active_users == 0 ? 1 : 0 }"
        />
    </div>
</template>
<script>
import { QTable } from "quasar";
import Report from "@/mixins/report";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import FilterPetCareUser from "@/module/report/module/filter-petcare-user";

export default {
    mixins: [Report],
    components: {
        QTable,
        FilterPetCareUser,
        ClientName: () => import("@/components/commons/client-name"),
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {}
        }
    },
    data() {
        return {
            locale: "en-US",
            loaded: false,
            meta: {},
            page: 1,
            pagination: {},
            results: [],
            total: 0,
            totalLoggedIn: 0,
            totalActive: 0,
            code: "",
            dateRange: "",
            renderedDateTime: moment().format("lll"),
            length: 0,
            params: {
                is_active_users: 0
            },
            isLoading: true,
            title: "PetCare Adoption",
            columns: [
                {
                    name: "firstname",
                    field: "firstname",
                    label: "First Name",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "lastname",
                    field: "lastname",
                    label: "Last Name",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "index",
                    field: "index",
                    label: "ID",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "first_login",
                    field: "first_login",
                    label: "First Login in PetCare",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "last_active",
                    field: "last_active",
                    label: "Last Active in PetCare",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "primary_reminder_pref",
                    field: "primary_reminder_pref",
                    label: "Primary Reminder Preference",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "address",
                    field: "address",
                    label: "Address",
                    align: "left",
                    style: "vertical-align: top; min-width: 200px;"
                },
                {
                    name: "city",
                    field: "city",
                    label: "City",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "state",
                    field: "state",
                    label: "State",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "zipcode",
                    field: "zipcode",
                    label: "Zip Code",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "county",
                    field: "county",
                    label: "County",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "country",
                    field: "country",
                    label: "Country",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "home_phone",
                    field: "home_phone",
                    label: "Home Phone",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "mobile_phone",
                    field: "mobile_phone",
                    label: "Mobile Phone",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "email",
                    field: "email",
                    label: "Email",
                    align: "left",
                    style: "vertical-align: top"
                }
            ]
        };
    },
    computed: {
        visibleColumns() {
            // display home_location column only if clinic is record sharing
            let cols = this.columns.map(e => e.field);
            // const index = cols.findIndex(e => e == "home_location");
            // if (!this.$root.setting.isRecordSharing) cols.splice(index, 1);
            return cols;
        },
        totalClientLoggedInTitle() {
            const title = "Total Clients Logged in (All Time)";
            return title + ":";
        },
        totalClientActiveTitle() {
            const title = "Total Clients Active within period";
            return title + ":";
        }
    },
    mounted() {
        let self = this;

        self.data.filterDateOption = false;

        this.$refs.filterPetCareUser.open();

        self.$root.$on("petcare_client_list:refresh", this.handleOnRefresh);

        self.$root.$on("petcare_client_list:load", this.handleOnFilterChanged);
    },
    beforeDestroy: function () {
        this.data.filterDateOption = true;
    },
    methods: {
        init(isRefresh = false, resetResult = false) {
            let self = this;

            clearInterval(self.pagination.interval);
            self.loadingPercentages();

            ReportService.getReport(CREPORT.TYPE.PETCARE_CLIENT_LIST, {
                ...self.params,
                refresh: isRefresh ? 1 : 0,
                page: self.pagination.page
            }).then(response => {
                const reportResponse = response.resource;
                const length = reportResponse.results.length;

                self.meta = {
                    ...reportResponse.meta,
                    ...reportResponse.paginate
                };

                self.loaded = true;
                self.code = response.status;
                self.dynamicPageTitle(self.title);
                self.total = reportResponse.paginate.total;
                self.pagination.lastPage = reportResponse.paginate.lastPage;
                self.pagination.page++;

                self.totalLoggedIn = reportResponse.total_logged_in;
                self.totalActive = reportResponse.total_active;

                if (resetResult) {
                    self.results = [];
                }

                if (length > 0) {
                    reportResponse.results.forEach(e => {
                        const client = {
                            id: e.client_id,
                            encoded_id: e.client_encoded_id,
                            firstname: e.first_name,
                            lastname: e.last_name
                        };

                        self.results.push({
                            id: e.client_id,
                            index: e.client_index,
                            encoded_id: e.client_encoded_id,
                            firstname: e.first_name,
                            lastname: e.last_name,
                            first_login: e.first_login,
                            last_active: e.last_active,
                            primary_reminder_pref:
                                e.primary_reminder_preference,
                            address: e.address,
                            city: e.city,
                            state: e.state,
                            zipcode: e.zipcode,
                            county: e.county,
                            country: e.country,
                            home_phone: e.home_phone,
                            mobile_phone: e.mobile_phone,
                            email: e.email,
                            client
                        });
                    });

                    self.length = self.results.length;
                }

                if (self.pagination.page <= self.pagination.lastPage) {
                    self.timer(self.INTERVAL_TIME).then(() => {
                        self.init(isRefresh);
                    });
                } else {
                    self.loadingCompleted();
                    self.isLoading = false;
                    self.loaded = true;
                }
            });
        },
        handleOnRefresh() {
            this.isLoading = true;
            this.pagination = this.DEFAULT_PAGINATION();
            this.length = 0;
            this.page = 1;
            this.init(true, true);
        },
        handleOnFilterChanged(params) {
            this.isLoading = true;
            this.loaded = true;
            this.pagination = this.DEFAULT_PAGINATION();
            this.length = 0;

            this.params = {
                is_active_users: params.is_active_users,
                interval_month: params.interval_month
            };

            if (
                params.to !== null &&
                params.to !== undefined &&
                !isNaN(params.to)
            ) {
                this.params.to = params.to; // Only add "to" if it's valid
            }

            this.init(false, true);

            this.$root.$emit("petcare_client_list:toggle", {
                is_active_users: this.params.is_active_users,
                interval_month: this.params.interval_month,
                to: this.params.to
            });
        },
        handleOpenFilter() {
            this.$refs.filterPetCareUser.open();
        },
        getClientURI(id) {
            return process.env.CI_APPS + "client/client/view/" + id + "/0";
        }
    }
};
</script>
<style scoped>
.summary-table h4 {
    margin-left: 0.75rem;
}
.summary-table tr td:first-child {
    width: 1%;
    white-space: nowrap;
}

.summary-table tr td {
    font-size: 1.125rem;
    font-weight: 700;
}

.arrow {
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    margin-bottom: 1px;
    margin-right: 0.4em;
    padding: 3px;
}

.right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}

button.btn {
    padding: 0.5rem 1rem;
    background-color: #e1e1e1;
    border: none;
    border-radius: 4px;
}
</style>
